// The project the person opened last: a bot without an earlier chat starts there, not in
// the first project by name ("Archive" was picked for someone working in another one).
const KEY = 'bb.project.last';

export const lastProject = {
  get() {
    try { return localStorage.getItem(KEY); } catch { return null; }
  },
  set(id) {
    try { localStorage.setItem(KEY, id); } catch { /* private mode */ }
  },
};
